/**
 * Method for replace values on string with {key}
 * @param template string with templates
 * @param params values to replace
 * @returns
 */
export const replaceParamsInStringTemplate = (
  template: string,
  params: Record<string, string>
) => {
  let replacedString = template;

  Object.keys(params).forEach((key) => {
    replacedString = replacedString.replace(`{${key}}`, params[key]);
  });
  return replacedString;
};

/**
 * Method that return the same value if is valid or else return a empty string
 * @param value to validate
 */
export const getValueOrElseEmptyString = (value: unknown) => value ?? '';

/**
 * Applies `.trim()` to each property of the object,
 * if any property has null or undefined it assigns an empty string,
 * if a property is a number converts it to a string before applying `.trim()`.
 * @param obj which values are to be processed
 */
export const trimObjectValues = (obj: object) => {
  for (const key in obj) {
    obj[key] = (obj[key] == null ? '' : String(obj[key])).trim();
  }
  return obj;
};

/**
 * Method that return src string value from html string image tag.
 * @param htmlStringImage image tag as string, example: "<img src="https://s7d2.scene7.com/is/image/Caterpillar/CM20240229-cc1cf-43aae?fmt=png-alpha">"
 */
export const getSrcFromHtmlStringImg = (htmlStringImage: string) => {
  const regex = new RegExp('src=["\']([^"\']*)["\']');
  const match = regex.exec(htmlStringImage);
  return match ? match[1] : null;
};
